<template>
  <div class="app-contractholder-data-form">
    <SimonModal
      :is-visible="showModal"
      @hide="back"
      id="change-contract-holder-modal"
      size="large"
      show-footer-buttons
      @btnLeft="back"
      @btnRight="next"
      :btn-left-title="getSlotText('btnPrev', 'Abbrechen')"
      :btn-right-title="getSlotText('btnNext', 'Weiter')"
      custom-modal-class="change-contract-holder-modal"
    >
      <template v-slot:modalTitle>
        <h3><slot name="headerModal">Vertragsinhaber/in beim aktuellen Anbieter</slot></h3>
      </template>
      <div class="form-wrapper">
        <b-form
          :id="'form' + _uid"
          :novalidate="true"
          class="contractholder-data-input-form"
          data-form-checkout-personal-data-input
          ref="form">
          <div class="form-row">
            <LabeledTextInput
              name="firstName"
              :model.sync="currentCustomer_.firstName"
              :invalid.sync="invalid.currentCustomer_.firstName"
              :validation="validations.currentCustomer_.firstName"
              :formatter="formatterCharFilterOnlyAplha"
              :mandatory="true"
              ref="nestedInputFirstName"
            >
              <template v-for="slot in possibleChildSlotsFor('FirstName')" v-slot:[`${slot.child}`]>
                <slot :name="`${slot.parent}`"></slot>
              </template>
            </LabeledTextInput>
            <LabeledTextInput
              name="LastName"
              :model.sync="currentCustomer_.lastName"
              :invalid.sync="invalid.currentCustomer_.lastName"
              :validation="validations.currentCustomer_.lastName"
              :formatter="formatterCharFilterOnlyAplha"
              :mandatory="true"
              ref="nestedInputLastName"
            >
              <template v-for="slot in possibleChildSlotsFor('LastName')" v-slot:[`${slot.child}`]>
                <slot :name="`${slot.parent}`"></slot>
              </template>
            </LabeledTextInput>
            <BirthdateInputValidation
              ref="nestedInputBirthDate"
              :invalid.sync="invalid.currentCustomer_.birthDate"
              :date.sync="currentCustomer.birthDate"
            >
              <template v-for="slot in possibleChildSlotsFor('Birthdate')" v-slot:[`${slot.child}`]>
                <slot :name="`${slot.parent}`"></slot>
              </template>
            </BirthdateInputValidation>
          </div>
        </b-form>
      </div>
    </SimonModal>
  </div>
</template>
<script>

import { BForm } from 'bootstrap-vue'
import { validationMixin } from 'vuelidate'
import isValid from '@/mixins/validators/isValid'
import syncProperty from '@/mixins/syncProperty'
import { maxLength, required } from 'vuelidate/lib/validators'
import logout from '@/mixins/logout'

import transaction from '@/mixins/transaction'
import validationFlow from '@/mixins/validators/validationFlow'
import formatterCharFilterOnlyAplha from '@/mixins/formatters/inputFormatter'
import BirthdateInputValidation from '@/components/forms/LabeledBirthdateInput.vue'
import SimonModal from '@/components/modal/SimonModal.vue'
import LabeledTextInput from '../../forms/LabeledTextInput.vue'

export const stepName = 'changeContractHolder'

export default {
  name: 'ContractHolderDataForm',
  data () {
    return {
      refreshKeyBirthDate: 0,
      invalid: {
        currentCustomer_: {
          firstName: null,
          lastName: null,
          birthDate: null
        }
      },
      validations: {
        currentCustomer_: {
          firstName: {
            required,
            maxLength: maxLength(50)
          },
          lastName: {
            required,
            maxLength: maxLength(50)
          }
        }
      }
    }
  },
  components: {
    LabeledTextInput,
    SimonModal,
    BForm,
    BirthdateInputValidation
  },
  props: {
    process: String
  },
  computed: {
    formInvalid: function () {
      return Object.entries(this.invalid.currentCustomer_)
        .map(([key, value]) => value)
        .some((value) => value === true)
    }
  },
  methods: {
    setContractHolder (contractHolder) {
      this.$store.commit(`checkoutv2/${this.process}/_mnpData/setContractHolder`, contractHolder)
    },
    forceValidationOnNestedInputs () {
      Object.entries(this.$refs).forEach(([key, comp]) => {
        if (/^nestedInput/.test(key) && comp !== undefined) {
          comp.vflowForceFeedback()
        }
      })
    },
    next () {
      this.forceValidationOnNestedInputs()
      if (!this.formInvalid) {
        this.setContractHolder(this.currentCustomer_)
        this.$emit('refresh')
        this.showModal = false
      } else {
        // ensure live feedback for validation errors
        this.vFlowGetFirstErrorElementName().then(function (result) {
          const data = {
            type: 'validation',
            message: 'required field missing',
            location: result + ' - unknown'
          }
          if (typeof window.trackingNS?.track?.tracking === 'function') {
            window.trackingNS.track.tracking('error', data)
          }
        })
      }
    },
    back () {
      this.$emit('cancel')
      this.showModal = false
    }
  },
  mixins: [
    transaction('contractHolderData'),
    validationMixin,
    isValid,
    logout,
    syncProperty('show', 'showModal'),
    syncProperty('currentCustomer', 'currentCustomer_'),
    validationFlow,
    formatterCharFilterOnlyAplha
  ]
}
</script>
